import { useAuth } from '@/zustand/auth-store';
import { useNavigate } from 'react-router';
import 'twin.macro';

const AuthRedirectFooter = ({ normalText, linkedText, link, hideBorder = false }) => {
  const removeEmail = useAuth(state => state.removeNewEmail);
  const navigate = useNavigate();
  const returnPath = localStorage.getItem('otp-return-path') || '/';

  return (
    <>
      {normalText && !hideBorder && <div tw="border border-stroke" />}
      <p tw="font-['Inter'] text-[1rem] max-md:text-[0.875rem] font-[600] text-center max-md:text-Primary_800 text-[#383737]">
        {normalText}
        <span
          onClick={() => {
            removeEmail();
            localStorage.removeItem('rehab-email');
            navigate(`${link ? link : returnPath}`, { replace: true });
          }}
          tw="font-['Inter'] ms-1  max-md:text-[0.875rem] font-semibold text-Primary_600 max-md:text-Primary_800 cursor-pointer"
        >
          {linkedText}
        </span>
      </p>
    </>
  );
};

export default AuthRedirectFooter;
